<template>
  <div>
    <HeaderNav/>
    <router-view></router-view>
    <Footer/>
  </div>
</template>

<script>
import HeaderNav from './HeaderNav'
import Footer from './Footer'

export default {
  name: 'home',
  components: {
    HeaderNav,
    Footer
  },
  created () {
    this.isMobile()
  },
  methods: {
    isMobile () {
      const { body } = document
      const WIDTH = 480
      const RATIO = 0
      const rect = body.getBoundingClientRect()
      if (rect.width - RATIO < WIDTH) {
        localStorage.setItem('ToggleDevice', 'mobile')
      } else {
        localStorage.setItem('ToggleDevice', 'desktop')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue